/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ScheduledDowntime } from './ScheduledDowntime';
import {
    ScheduledDowntimeFromJSON,
    ScheduledDowntimeFromJSONTyped,
    ScheduledDowntimeToJSON,
} from './ScheduledDowntime';

/**
 * 
 * @export
 * @interface ListScheduledDowntimeResponse
 */
export interface ListScheduledDowntimeResponse {
    /**
     * 
     * @type {Array<ScheduledDowntime>}
     * @memberof ListScheduledDowntimeResponse
     */
    oneOff: Array<ScheduledDowntime>;
    /**
     * 
     * @type {Array<ScheduledDowntime>}
     * @memberof ListScheduledDowntimeResponse
     */
    recurring: Array<ScheduledDowntime>;
}

/**
 * Check if a given object implements the ListScheduledDowntimeResponse interface.
 */
export function instanceOfListScheduledDowntimeResponse(value: object): value is ListScheduledDowntimeResponse {
    if (!('oneOff' in value) || value['oneOff'] === undefined) return false;
    if (!('recurring' in value) || value['recurring'] === undefined) return false;
    return true;
}

export function ListScheduledDowntimeResponseFromJSON(json: any): ListScheduledDowntimeResponse {
    return ListScheduledDowntimeResponseFromJSONTyped(json, false);
}

export function ListScheduledDowntimeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListScheduledDowntimeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'oneOff': ((json['oneOff'] as Array<any>).map(ScheduledDowntimeFromJSON)),
        'recurring': ((json['recurring'] as Array<any>).map(ScheduledDowntimeFromJSON)),
    };
}

export function ListScheduledDowntimeResponseToJSON(value?: ListScheduledDowntimeResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'oneOff': ((value['oneOff'] as Array<any>).map(ScheduledDowntimeToJSON)),
        'recurring': ((value['recurring'] as Array<any>).map(ScheduledDowntimeToJSON)),
    };
}

